
    /**
     * Delete first occurance obj in this array.
     * @param {*} obj
     */
     Array.prototype.deleteFirst = function (obj, szProperty) {
        var idx = this.jeFindIndex(obj, szProperty);
        if (idx >= 0) {
            this.deleteAt(idx);
        }
    };

    Array.prototype.deleteAt = function (idx) {
        if (idx > -1) {
            this.splice(idx, 1);
        }
    };

    Array.prototype.insertAt = function (idx, item) {
        if (idx > -1) {
            this.splice(idx, 0, item)        
        }
    };

    Array.prototype.unReactiveObject = function () {
        return jng.unReactiveObject(this);
    };

    Array.prototype.deleteUsingEquality = function (equalityFunc, deleteFunc) {
        var idx = 0;
        while (idx < this.length) {
            if (equalityFunc(this[idx])) {
                if (jng.isUndefined(deleteFunc)) {
                    this.deleteAt(idx);
                } else {
                    deleteFunc(idx);
                }
            } else {
                idx += 1;
            }
        }
    };

    Array.prototype.removeAll = function () {
        this.splice(0, this.length);
    };

    Array.prototype.setValueInArrayUsingFunc = function (szProperty, funcValueForItem) {
        var idx, max;
        for (idx = 0, max = this.length; idx < max; idx += 1) {
            this[idx][szProperty] = funcValueForItem(this[idx]);
        }
    };

    Array.prototype.addRange = function (listObj) {
        if (jng.isDefined(listObj)) {
            var i, max;
            for (i = 0, max = listObj.length; i < max; i += 1) {
                this.add(listObj[i]);
            }
        }
    };

    Array.prototype.pushAll = function (listObj) {
        if (jng.isDefined(listObj)) {
            var i, max;
            for (i = 0, max = listObj.length; i < max; i += 1) {
                this.push(listObj[i]);
            }
        }
    };

    Array.prototype.jeFindIndex = function (obj, szProperty) {
        var idx, max;
        if (jng.isUndefined(obj)) {
            return -1;
        }
        if (jng.isArray(obj)) {
            for(idx = 0, max = obj.length; idx < max; idx += 1) {
                var result = this.jeFindIndex(obj[idx], szProperty);
                if (result !== -1) return result;
            }
        } else {
            for (idx = 0, max = this.length; idx < max; idx += 1) {
                if (!jng.isObject(this[idx]) || jng.isUndefined(szProperty)) {
                    if (jng.isValueEqual(this[idx], obj)) {
                        return idx;
                    }
                } else {
                    var arrItem = jng.getValueOfObject(this[idx], szProperty);
                    if (jng.isValueEqual(arrItem, obj)) {
                        return idx;
                    }
                }
    
            }
        }
        
        return -1;
    };

    Array.prototype.findIndexUsingEquality = function (equalityFunc) {
        var idx, max;
        for (idx = 0, max = this.length; idx < max; idx += 1) {
            if (equalityFunc(this[idx])) {
                return idx;
            }
        }
        return -1;
    };

    Array.prototype.findIndexByObject = function (data1, funcOrArzProperty) {
        var idx;
        for (idx = 0; idx < this.length; idx += 1) {
            if (jng.isFunction(funcOrArzProperty)) {
                if (funcOrArzProperty(this[idx], data1)) {
                    return idx;
                }
            } else {
                if (jng.isObjectEqual(this[idx], data1, funcOrArzProperty)) {
                    return idx;
                }
            }
        }
        return -1;
    };

    Array.prototype.findFirst = function (obj, szProperty) {
        var idx = this.jeFindIndex(obj, szProperty);
        if (idx < 0) {
            return undefined;
        }
        return this[idx];
    };

    Array.prototype.findFirstUsingEquality = function (equalityFunc) {
        var idx = this.findIndexUsingEquality(equalityFunc);
        if (idx === -1) {
            return undefined;
        }
        return this[idx];
    };


    Array.prototype.isExists = function (obj, szProperty) {
        var idx = this.jeFindIndex(obj, szProperty);
        return idx >= 0;
    };

    Array.prototype.isExistsByObject = function (data1, funcOrArzProperty) {
        var idx = this.findIndexByObject(data1, funcOrArzProperty);
        if (idx === -1) {
            return false;
        }
        return true;
    };

    Array.prototype.orderBy = function (arzProperty, order) {
        function compare(data1, data2) {
            var idxHeader;
            for (idxHeader = 0; idxHeader < arzProperty.length; idxHeader += 1) {
                var valueData1 = jng.coalesce(data1[arzProperty[idxHeader]], '');
                var valueData2 = jng.coalesce(data2[arzProperty[idxHeader]], '');
                var result = 0;
                if (valueData1 < valueData2) {
                    result = -1;
                } else if (valueData1 > valueData2) {
                    result = 1;
                }
                if (result !== 0) {
                    if (jng.coalesce(order, 'ASC') === 'ASC') {
                        return result;
                    } else {
                        return result * -1;
                    }
                }
            }
            return 0;
        }

        return this.sort(compare);
    };

    Array.prototype.add = function (obj) {
        this[this.length] = obj;
        //this.push(obj);
    };

    Array.prototype.findAllByArray = function (arrObj, arzProperty) {
        function isObjectEqual(data) {
            var idxHeader;
            for (idxHeader = 0; idxHeader < arzProperty.length; idxHeader += 1) {
                var valueData1 = data[arzProperty[idxHeader]];
                var valueData2 = arrObj[idxHeader];
                if (!jng.isValueEqual(valueData1, valueData2)) {
                    return false;
                }
            }
            return true;
        }
        //Begin Code
        var result = [];
        if (jng.isUndefined(arrObj)) {
            return result;
        }
        var idx, max;
        for (idx = 0, max = this.length; idx < max; idx += 1) {
            if (isObjectEqual(this[idx])) {
                result.add(this[idx]);
            }
        }
        return result;
    };

    Array.prototype.findAll = function (obj, property) {
        return this.findAllByArray([obj], [property]);
    };

    Array.prototype.findAllUsingEquality = function (equalityFunc) {
        var result = [];
        var idx, max;
        for (idx = 0, max = this.length; idx < max; idx += 1) {
            if (equalityFunc(this[idx])) {
                result.push(this[idx]);
            }
        }
        return result;
    };

    Array.prototype.groupBy = function (headerProperties, szItemName) {
        function getResultIndex(result, data) {
            var idxResult;
            for (idxResult = 0; idxResult < result.length; idxResult += 1) {
                if (jng.isObjectEqual(result[idxResult], data, headerProperties)) {
                    return idxResult;
                }
            }
            return -1;
        }
        function createNewHeaderData(data) {
            var resultItem = {};
            var idxHeader;
            for (idxHeader = 0; idxHeader < headerProperties.length; idxHeader += 1) {
                var valueData = data[headerProperties[idxHeader]];
                resultItem[headerProperties[idxHeader]] = valueData;
            }
            return resultItem;
        }

        //Begin - code
        var itemName = jng.isDefined(szItemName) ? szItemName : "items";
        var result = [];
        var idx, max;
        for (idx = 0, max = this.length; idx < max; idx += 1) {
            var data = this[idx];
            var idxResult = getResultIndex(result, data);
            var resultItem;
            if (idxResult < 0) {
                resultItem = createNewHeaderData(data);
                resultItem[itemName] = [];
                result.push(resultItem);
            } else {
                resultItem = result[idxResult];
            }
            resultItem[itemName].push(data);
        }
        return result;
    };

    Array.prototype.ungroupBy = function (szItemName) {
        var itemName = jng.isDefined(szItemName) ? szItemName : "items";

        function updateItemWithHeader(dataItem, dataHeader) {
            var prop;
            for (prop in dataHeader) {
                if (dataHeader.hasOwnProperty(prop)) {
                    if (prop !== itemName) {
                        dataItem[prop] = dataHeader[prop];
                    }
                }
            }
        }
        //Begin - code
        var result = [];
        var idx, max;
        for (idx = 0, max = this.length; idx < max; idx += 1) {
            var data = this[idx];
            var itemIdx;
            for (itemIdx = 0; itemIdx < data[itemName].length; itemIdx += 1) {
                var dataItem = data[itemName][itemIdx];
                updateItemWithHeader(dataItem, data);
                result.add(dataItem);
            }
        }
        return result;
    };

    
    
    Array.prototype.setValueInArray = function (szProperty, funcOrValue) {
        var idx, max;
        for (idx = 0, max = this.length; idx < max; idx += 1) {
            if (jng.isFunction(funcOrValue)) {
                this[idx][szProperty] = funcOrValue(this[idx]);
            } else {
                this[idx][szProperty] = funcOrValue;
            }
        }
    };

    Array.prototype.extractSingleValue = function (szProperty) {
        var result = [];
        var i;
        for (i = 0; i < this.length; i += 1) {
            result.add(this[i][szProperty]);
        }
        return result;
    };

    Array.prototype.cloneLiteral = function () {
        var result = [];
        var i;
        for (i = 0; i < this.length; i += 1) {
            result.push(jng.cloneLiteral(this[i]));
        }
        return result;
    };

    Array.prototype.clone = function () {
        var result = [];
        var i;
        for (i = 0; i < this.length; i += 1) {
            result.push(jng.clone(this[i]));
        }
        return result;
    };

    Array.prototype.copy = function () {
        var result = [];
        var i;
        for (i = 0; i < this.length; i += 1) {
            result.add(this[i]);
        }
        return result;
    };


    Array.prototype.extract = function (arzProperty) {
        var result = [];
        var i;
        for (i = 0; i < this.length; i += 1) {
            var resultItem = jng.extract(this[i], arzProperty);
            result.add(resultItem);
        }
        return result;
    };

    Array.prototype.distinct = function (arzProperty) {

        var result = [];
        var tmpResult = this.extract(arzProperty);

        var idx, max;
        for (idx = 0, max = tmpResult.length; idx < max; idx += 1) {
            if (!result.isExistsByObject(tmpResult[idx], arzProperty)) {
                result.add(tmpResult[idx]);
            }
        }
        return result;
    };

    Array.prototype.addDistinct = function (obj, arzPropOrFunc) {
        var idx;
        if (jng.isFunction(arzPropOrFunc)) {
            idx = this.findIndexUsingEquality(arzPropOrFunc);
        } else {
            idx = this.findIndexByObject(obj, arzPropOrFunc);
        }
        if (idx === -1) {
            this[this.length] = obj;
        }
        //this.push(obj);
    };

    Array.prototype.equals = function (arr, arzProp) {
        if (this.length !== arr.length) return false

        for(let i = 0; i < this.length; i++) {
            let idx = arr.findIndexByObject(this[i], arzProp);
            if (idx < 0) return false
        }
        return true
    };

    Array.prototype.toString = function (delimiter) {
        if (this.length == 0) return ''
        let result = ''
        for(let i = 0; i < this.length; i++) {
            result += this[i]
            if (i < this.length - 1) {
                result += ","
            }
        }
        return result
    };

    
jng.multiDuplicateRemove = function(arr, multiSzProp){
    if(jng.isArray(arr)){
        let collection = [];
        let result = [];
        let multiAction = " ";
        for(let msz of multiSzProp){
            multiAction += 'prop["'.concat(msz, '"] == item["', msz, '"] && ');
        }
        for(let prop of arr.clone()){
            let findRes = collection.findFirstUsingEquality((item)=>{
                return eval(multiAction.slice(0, multiAction.length-3));
            });
            if(jng.isDefined(findRes)){
                continue;
            }else{
                collection.push(prop);
                result.push(prop);
            }
        }

        return result;
    }else{
        console.log("must be array")
        return [];
    }
}


jng.arrayDistinct = function(arr, arzProp){
    if(arr.length>0){
        let newArr = [];
        let arrDistinct = arr.distinct(arzProp);
        for(let obj of arrDistinct){
            let opt = arr.find(e=>e[arzProp[0]] == obj[arzProp[0]]);
            if(jng.isDefined(opt))newArr.push(opt);
        }
        return newArr;
    }else return arr;
}


jng.checkDuplicateItem = function(arr,szProp){
    let result = false
    if(jng.isArray(arr)){
        let groupted = arr.groupBy([szProp])
        groupted.traverse((item)=>{
            if(item.items.length > 1){
                result = true
            }
        })
    }
    return result
}


jng.duplicateRemove = function(arr, szProp){
    if(jng.isArray(arr)){
        let collection = [];
        let result = [];
        for(let prop of arr.clone()){
            let findRes = collection.findFirst(prop[szProp], szProp);
            if(jng.isDefined(findRes)){
                continue;
            }else{
                collection.push(prop);
                result.push(prop);
            }
        }
        if(szProp == undefined){
            result = [];
            for(let obj of arr.clone()){
                if(result.indexOf(obj) === -1){
                    result.push(obj);
                }
            }
        }

        return result;
    }
}

jng.makeAsArray = function (data) {
    if (jng.isArray(data)) {
        return data;
    }
    var result = [];
    result[0] = data;
    return result;
};

jng.extract = function (obj, arzProperty) {
    var resultItem = {};
    var j;
    for (j = 0; j < arzProperty.length; j += 1) {
        resultItem[arzProperty[j]] = obj[arzProperty[j]];
    }
    return resultItem;
};